<div class="dialog-content-wrapper" fusePerfectScrollbar>
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex flex-row justify-between items-center flex-1">
      <ng-container *ngIf="selectedProductId; else elseTemplateTitle">
        <span class="title dialog-title" i18n>Карточка товара</span>
      </ng-container>
      <ng-template #elseTemplateTitle>
        <span class="title dialog-title" i18n>Список изделий</span>
      </ng-template>

      <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="no-padding overflow-hidden flex-1">
    <div class="loading flex flex-col gap-6 justify-center items-center" *ngIf="loading">
      <mat-spinner></mat-spinner>
      <div i18n class="h1">ЗАГРУЗКА МОДЕЛИ</div>
    </div>

    <div class="h-full w-full flex flex-col" *ngIf="!selectedProductId">
      <!-- LIST TOOLBAR -->
      <mat-toolbar class="m-0">
        <mat-toolbar-row class="flex flex-row gap-6 justify-between items-center flex-1">
          <mat-form-field appearance="outline" class="dense-input no-subscript flex-1">
            <input matInput #productSearch i18n-placeholder placeholder="Поиск" />
            <button
              mat-button
              *ngIf="productSearch.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="productSearch.value = ''; productsList.first.filter.next('')">
              <mat-icon class="s-16">close</mat-icon>
            </button>
          </mat-form-field>

          <div [ngClass]="{ hidden: priceLists?.length < 2 }" class="flex flex-row gap-2 items-center">
            <div i18n class="mat-body-1 mt-2">Каталог</div>
            <mat-form-field appearance="outline" class="dense-input no-subscript">
              <mat-select
                i18n-placeholder
                placeholder="Каталог"
                [(ngModel)]="selectedPriceList"
                (ngModelChange)="priceListChanged($event)">
                <mat-option *ngFor="let item of priceLists" [value]="item">
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div [ngSwitch]="productsViewMode" (click)="toggleViewMode()">
            <button
              *ngSwitchCase="'view_list'"
              mat-stroked-button
              color="primary"
              class="p-0 w-10"
              i18n-matTooltip
              matTooltip="Отображение элементов в виде карточек">
              <mat-icon class="s-28 secondary-text">view_module</mat-icon>
            </button>
            <button
              *ngSwitchCase="'view_module'"
              mat-stroked-button
              color="primary"
              class="p-0 w-10"
              i18n-matTooltip
              matTooltip="Отображение элементов в виде таблицы">
              <mat-icon class="s-28 secondary-text">view_list</mat-icon>
            </button>
          </div>
        </mat-toolbar-row>
      </mat-toolbar>
      <!-- / LIST TOOLBAR -->

      <mat-divider> </mat-divider>

      <div class="flex flex-row items-start overflow-hidden" *ngIf="selectedPriceList" fusePerfectScrollbar>
        <div class="groups-wrapper h-full basis-72" *ngIf="!productSearch.value" fusePerfectScrollbar>
          <cutting-price-list-product-groups
            class="tree-component"
            [priceListId]="selectedPriceList ? selectedPriceList.id : 0"
            #productGroups
            [activeNodeId]="selectedGroupId"
            (selectedGroupChange)="groupChanged($event)">
          </cutting-price-list-product-groups>
        </div>
        <div class="h-full flex-1" #productsWrapper>
          <cutting-price-list-products
            [priceList]="selectedPriceList ? selectedPriceList : undefined"
            *ngIf="productsViewMode === 'view_list'"
            #productsList
            (selectedProductChange)="showProductCard($event)"
            [selectedGroupId]="selectedGroupId">
          </cutting-price-list-products>

          <cutting-price-list-products-carded
            [priceList]="selectedPriceList ? selectedPriceList : undefined"
            *ngIf="productsViewMode === 'view_module'"
            #productsList
            (selectedProductChange)="showProductCard($event)"
            [selectedGroupId]="selectedGroupId">
          </cutting-price-list-products-carded>
        </div>
      </div>
    </div>

    <div *ngIf="selectedProductId" fusePerfectScrollbar class="flex-1 h-full w-full min-h-full min-w-full">
      <cutting-price-list-product-detail
        [priceList]="selectedPriceList ? selectedPriceList : undefined"
        (hasErrorsChange)="productFormValid = !$event"
        #productDetail
        [selectedProductId]="selectedProductId"
        [userId]="userId()"
        [productNum]="productNum">
      </cutting-price-list-product-detail>
    </div>
  </div>

  <mat-divider> </mat-divider>

  <div mat-dialog-actions *ngIf="selectedProductId" class="m-0 p-4 flex flex-row-reverse justify-between items-center">
    <div>
      <button mat-raised-button [disabled]="!productFormValid" class="mat-accent" (click)="saveAndClose()" i18n
        >ОК</button
      >
      <button mat-button (click)="dialogRef.close(undefined)" i18n>ОТМЕНА</button>
    </div>

    <button mat-button (click)="selectedProductId = 0" i18n>НАЗАД</button>
  </div>
</div>
